import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

enum UserState {
  LOADING = 'Loading',
  READY = 'Ready'
}

export const MOBILE_BREAKPOINT = 768
export const TABLET_BREAKPOINT = 1024
export const TABLET_LANDSCAPE_BREAKPOINT = 1280

export const useWebAppStore = defineStore('webApp', () => {
  const userInfoState = ref(UserState.LOADING)

  const isDeviceMobileScreen = ref(window.innerWidth < MOBILE_BREAKPOINT)
  const isDeviceTabletScreen = ref(window.innerWidth < TABLET_BREAKPOINT)
  const isDeviceTabletLandscapeScreen = ref(window.innerWidth < TABLET_LANDSCAPE_BREAKPOINT)
  const sideNavDisplayIsAllowed = ref(true)

  const setUserInfoReadyState = () => {
    userInfoState.value = UserState.READY
  }

  const setNavigationDisplay = (value: boolean) => {
    sideNavDisplayIsAllowed.value = value
  }

  const isUserInfoReady = computed(() => userInfoState.value === UserState.READY)
  const isTabletMode = computed(() => isDeviceTabletScreen.value)
  const navIsDisplayed = computed(() => !isTabletMode.value && sideNavDisplayIsAllowed.value)
  const isAppReady = computed(() => isUserInfoReady.value)

  const setWidth = () => {
    isDeviceMobileScreen.value = window.innerWidth < MOBILE_BREAKPOINT
    isDeviceTabletScreen.value = window.innerWidth < TABLET_BREAKPOINT
    isDeviceTabletLandscapeScreen.value = window.innerWidth < TABLET_LANDSCAPE_BREAKPOINT
  }

  return {
    setUserInfoReadyState,
    setNavigationDisplay,
    setWidth,
    isUserInfoReady,
    navIsDisplayed,
    isAppReady,
    userInfoState,
    isDeviceMobileScreen,
    sideNavDisplayIsAllowed,
    isDeviceTabletLandscapeScreen,
    isTabletMode
  }
})
